export default "__VITE_ASSET__CNRF_DfL__"